<template>
  <div class="post h-100">
    <PostProvider :id="id" v-slot="{ post, update, remove }">
      <PostForm
        :post="post"
        :removeable="true"
        :submit-text="$t('admin.update')"
        @submit-handler="update"
        @remove-handler="remove(post.id)"
        v-if="post"
      />
    </PostProvider>
  </div>
</template>

<script>
import { PostProvider } from '@/core/providers';
import PostForm from '@/modules/admin/components/PostForm';

export default {
  name: 'Post',
  components: {
    PostProvider,
    PostForm,
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
};
</script>